import { makeStyles, useTheme } from "@material-ui/core";
import type { TimelineProps } from "@material-ui/lab";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    padding: "3px 0 0 16px",
  },
  content: {
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.grey[400],
    display: "flex",
  },
  item: {
    minHeight: "45px",
  },
  dotted: {
    borderRight: `3px dotted ${theme.palette.mono.gray}`,
    backgroundColor: "inherit",
  },
  dot: {
    border: `1px solid ${theme.palette.mono.secondaryDark}`,
    boxShadow: "none",
  },
  label: {
    width: "45px",
    textAlign: "right",
    color: theme.palette.mono.secondaryDark,
  },
  date: {
    paddingLeft: "16px",
    color: theme.palette.colour.primaryBlue,
  },
}));

interface RangeTimeline extends TimelineProps {
  from: string;
  to: string;
}

const RangedTimeline = ({ from, to }: RangeTimeline): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme() as CoretexTheme;
  return (
    <Timeline>
      <TimelineItem className={classes.item}>
        <TimelineSeparator>
          <TimelineDot variant="outlined" className={classes.dot} />
          <TimelineConnector className={classes.dotted} />
        </TimelineSeparator>
        <TimelineContent classes={{ root: classes.root }}>
          <div className={classes.content}>
            <div className={classes.label}>{from}</div>
            <div className={classes.date}>Today, 11:00AM</div>
          </div>
        </TimelineContent>
        <TimelineOppositeContent style={{ display: "none" }} />
      </TimelineItem>
      <TimelineItem className={classes.item}>
        <TimelineSeparator>
          <TimelineDot className={classes.dot} style={{ backgroundColor: theme.palette.mono.secondaryDark }} />
        </TimelineSeparator>
        <TimelineContent classes={{ root: classes.root }}>
          <div className={classes.content}>
            <div className={classes.label}>{to}</div>
            <div className={classes.date}>Today, 11:00AM</div>
          </div>
        </TimelineContent>
        <TimelineOppositeContent style={{ display: "none" }} />
      </TimelineItem>
    </Timeline>
  );
};

export default RangedTimeline;
